import { render } from "./SessionDots.vue?vue&type=template&id=7544fe40"
import script from "./SessionDots.vue?vue&type=script&lang=js"
export * from "./SessionDots.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__